import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import ErrorBoundary from "./ErrorBoundary";
import i18n from "@/i18n";

/** All cross-cutting context providers, composed in one place. */
export function AppProviders({ children }) {
  return (
    <ErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <HelmetProvider>
          <BrowserRouter>{children}</BrowserRouter>
        </HelmetProvider>
      </I18nextProvider>
    </ErrorBoundary>
  );
}

export default AppProviders;
